<template lang="html">
  <div class="messages">
    <div class="titleBloc d-flex flex-column justify-content-center">
      <div class="title">{{ $tlang(lg1, 'mercure.rates.rightTitles.message') }}</div>
      <div class="subtitle">{{ $tlang(lg2, 'mercure.rates.rightTitles.message') }}</div>
    </div>
    <div class="message d-flex flex-column justify-content-around" v-for="(message, index) in filteredMessages">
      <div class="name">{{message.mm_value}}</div>
      <div class="label lg1">{{ $tlang(lg1, 'mercure.rates.clientMessage') }}</div>
      <div class="label lg2">{{ $tlang(lg2, 'mercure.rates.clientMessage') }}</div>
    </div>
  </div>
</template>

<script lang="js">
  export default {
    name: 'messages',
    props: ['messages', 'rightTitle'],
    mounted () {
    },
    data () {
      return {
        msgByPages: 5,
        currentPage: 1
      }
    },
    methods: {
      nextPage () {
        this.currentPage++
        if (this.currentPage > this.pages) {
          this.currentPage = 1
        }
        if (this.currentPage === this.pages) {
          return false // last page
        } else {
          return true
        }
      }
    },
    computed: {
      pages () {
        return Math.ceil(this.messages.clients_messages.length / this.msgByPages)
      },
      filteredMessages () {
        let start = (this.currentPage - 1) * this.msgByPages
        return this.messages.clients_messages.slice(start, start + this.msgByPages)
      },
      lg1 () {
        return this.$store.getters.site.get('rates').get('data').languages[0].name.toLowerCase()
      },
      lg2 () {
        return this.$store.getters.site.get('rates').get('data').languages[1].name.toLowerCase()
      }
    }
}
</script>

<style scoped lang="scss">
$srcWidth: 1920;
$srcHeight: 1080;
@import "../../../../../_novotel.scss";

.messages {
  margin-top: 50 * 90vh / $srcHeight;
  @include heightPercent(651);
  @include widthPercent(386);
  border-top: 1px solid $purple;
  font-family: "HouschkaAltPro-Medium";

  .message {
    border-bottom: 1px solid $purple;
    @include heightPercent(130);

    .name {
      color: $purple;
      margin-top: 1rem;
      text-transform: uppercase;
      font-size: 1rem;
    }

    .label {
      font-size: 0.7rem;

      &:first-letter {
        text-transform: uppercase;
      }

      &.lg2 {
        margin-bottom: 1rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/novotel/rates/horizontal/v1/right/messages/messages.vue